import { FormattedMessage } from 'react-intl';
import { PaloReviewReminder } from '@synergy/components-palo';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router';

import { useSelector } from '../../../store/use-appstate-selector';

export const UserManagementReviewPopup = (): ReactElement | null => {
    const navigate = useNavigate();
    const account = useSelector(state => state.currentAccount);

    if (!account) {
        return null;
    }

    return (
        <PaloReviewReminder due={!!account.accountNeedsToBeChecked} onGoToList={() => navigate('/userManagement')}>
            <FormattedMessage id="app.user.management.reminderText" />
        </PaloReviewReminder>
    );
};
